import React from 'react';
import type { Message as MessageType } from '../../../types/chat';

interface MessageProps {
  message: MessageType;
}

export function Message({ message }: MessageProps) {
  const isAssistant = message.role === 'assistant';

  return (
    <div className={`font-mono text-sm ${isAssistant ? 'text-cyan-500' : 'text-green-400'}`}>
      <div className="whitespace-pre-wrap">{message.content}</div>
    </div>
  );
}